export const AreasMock = [
  {
    Id: 3211,
    AreaNameAr: "string",
    AreaNameEn: "AreaNameEn",
    CompanyId: 3211,
    Company: {
      Id: 1111,
      CompanyNameAr: "string",
      CompanyNameEn: "CompanyNameEn",
      ActivityAr: "string",
      ActivityEn: "string",
      OilNumber: 1111,
      Visible: true,
      Value: "string",
    },
    CompanyNameAr: "string",
    CompanyNameEn: "string",
    AreaLocation: "string",
    CicpaCode: 3211,
    IsVisible: true,
  },
  {
    Id: 32110,
    AreaNameAr: "string",
    AreaNameEn: "AreaNameEn 1",
    CompanyId: 3211,
    Company: {
      Id: 1111,
      CompanyNameAr: "string",
      CompanyNameEn: "CompanyNameEn 1",
      ActivityAr: "string",
      ActivityEn: "string",
      OilNumber: 1111,
      Visible: true,
      Value: "string",
    },
    CompanyNameAr: "string",
    CompanyNameEn: "string",
    AreaLocation: "string",
    CicpaCode: 3211,
    IsVisible: true,
  },
  {
    Id: 32113,
    AreaNameAr: "string",
    AreaNameEn: "AreaNameEn 2",
    CompanyId: 32113,
    Company: {
      Id: 11113,
      CompanyNameAr: "string",
      CompanyNameEn: "CompanyNameEn 2",
      ActivityAr: "string",
      ActivityEn: "string",
      OilNumber: 11113,
      Visible: true,
      Value: "string",
    },
    CompanyNameAr: "string",
    CompanyNameEn: "string",
    AreaLocation: "string",
    CicpaCode: 32113,
    IsVisible: true,
  },
  {
    Id: 321134,
    AreaNameAr: "string",
    AreaNameEn: "AreaNameEn 3",
    CompanyId: 321134,
    Company: {
      Id: 111134,
      CompanyNameAr: "string",
      CompanyNameEn: "CompanyNameEn 3",
      ActivityAr: "string",
      ActivityEn: "string",
      OilNumber: 111134,
      Visible: true,
      Value: "string",
    },
    CompanyNameAr: "string",
    CompanyNameEn: "string",
    AreaLocation: "string",
    CicpaCode: 321134,
    IsVisible: true,
  },
];
